import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import Add from './icon-add.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Add {...validProps} />;
}
SvgComponent.iconName = 'add';

/**
 * @deprecated This is a legacy icon
 */
export const AddIcon = svgIconWrapper(SvgComponent);
